export default {
    waiting(state) {
        return state.waiting
    }
}